import {styled} from '@mui/material/styles';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
// // import Alert from '@mui/material/Alert';
// import { useTranslation } from 'react-i18next';


import { 
    WhiteSpace,
    TextL,
    Button,
    TextLinear,
    TextXL,
    TextMax,
    TextM,
    TextS,
    Hr,
    Input,
    Card,
    FlexBLock,
    WhiteSpaceVertical,
    Dialog,
    LoadingBlock,
} from '../../components';

import {IconImg} from '../../components/Icon'

import {
    WeiToUnits,
    EtherToWei,
    EtherToInt,
    ShortAddress
} from '../../ethers/e'

import { memo } from 'react';

import {
    useNodeData,
    useBuyNode,
    useClaim
} from '../../hook/ma/useNode'

import {
    useBalance
} from '../../context/balance'

import {ProtocolSignDrawer} from '../Protocol'

import Loading from './Loading'


// const COLORS = {
//     up: "#f13232",
//     down: '#1ce81c'
// }
const Price = memo(function () {
    const p = useBalance()
    return (
        <div style={{textAlign:'right'}}>
            <TextS style={{lineHeight: '12px'}} block>CVC<TextS color='2'> / USDT </TextS></TextS>
            <TextS style={{lineHeight: '20px', fontSize: '16px'}}>{p.prices.CVC.toFixed(6)} {/*<TextS style={{color: COLORS.up}}>+ 0.36%</TextS>*/}</TextS>
        </div>
    )
})

function ClaimUSDT() {
    return <Button {...useClaim()} /> 
}


function InvestProcess(amountInput, usdtInvested) {
    let p = ((amountInput || 0)*1 + usdtInvested * 1)  / 3000 * 100
    return Math.min(p, 100).toFixed(2)
}
function JoinNode({registed, usdtInvested}) {
    const p = useBalance()
    const {
        button,
        sponsorInput,
        hashInput,
        amountInput
    } = useBuyNode()
    
    const requireSign = hashInput.value === ''


    const investProcess = InvestProcess(amountInput.value , usdtInvested)
    const max = () => {
        amountInput.onChange(
            Math.min(p.balances.USDT*1, 3000 - usdtInvested)
        )
    }
    return (
        <Card>
            <TextL block>Join Node</TextL>
            <FlexBLock>
                <TextS>Invested <TextLinear>{EtherToInt(usdtInvested)}</TextLinear> USDT</TextS>
                <TextS>Balance <TextLinear>{EtherToInt(p.balances.USDT)}</TextLinear> USDT</TextS>
            </FlexBLock>
            <Input
                after={<Button size='small' type='a' onClick={max}>Max</Button>}
                input={amountInput}
            />
            <WhiteSpace />
            <FlexBLock>
                <TextS>Invest 3,000 USDT into Node</TextS>
                <TextS>{investProcess}%</TextS>
            </FlexBLock>
            <Loading progress={investProcess}/>
            {
                !registed &&
                <>
                    <WhiteSpace />
                    <TextS>Sponsor Address</TextS>
                    <Input
                        // after={<Button size='small' type='d' onClick={()=>{}}>Max</Button>}
                        input={sponsorInput}
                    />
                </>
                
            }
            
            <WhiteSpace />
            <Button type='b' style={{width: '100%'}}>Updating</Button>
            {/* {
                requireSign ? 
                <ProtocolSignDrawer
                    buttonStyle={{
                        type:'b',
                        style: {width: '100%'}
                    }}
                    onComfirm={hash => {
                        // console.log(hash, " hash")
                        hashInput.onChange(hash)
                    }}
                />:
                <Button type='b' style={{width: '100%'}} {...button}/>
            } */}
            <WhiteSpace />
            <Hr/>
            <WhiteSpace />
            <TextM>Node Purchase Rules</TextM>
            <RulesBlock>
                <TextM block>Rewards:</TextM>
                <TextS block>· Direct Referral Bonus: 10%</TextS>
                <TextS block>· Indirect Referral Bonus: 10%</TextS>
                <TextS block>· Team Bonus: 10%</TextS>
                <TextS block>· Queue Dividend: 15%</TextS>
                <TextS block>· LP: 35%</TextS>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <TextM block>Level Upgrade Rules:</TextM>
                <TextS block>· After node registration, users will start at Level 13 in the mutual assistance system.</TextS>
                <TextS block>· By completing 3 valid direct referrals and 9 indirect referrals, you can upgrade to Level 14.</TextS>
                <TextS block>· When each of your 3 direct referrals and 9 indirect referrals also completes 3 valid direct referrals and 9 indirect referrals, you will gain +1 level per chain, for a total of 13 levels (1×13 = 13). Combined with your previous 13 levels, this results in Level 26.</TextS>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <TextM block>Team Bonus:</TextM>
                <TextS block>· When your 3 direct referrals and 9 indirect referrals form a complete team (13 nodes in total), you will receive a bonus of 1,350 U for each completed team.</TextS>
                <TextS block>· You can earn this reward up to 12 times.</TextS>
            </RulesBlock>
        </Card>
    )
}

const IDENTITY_TYPE = ["User", "Node", "FullNode", "Leader"]
function TeamItem({user, vip, identity, invested, ...prop}) {
    return (
        <FlexBLock {...prop}>
            <TextS>{ShortAddress(user, 6)} - [{EtherToInt(invested)} U]</TextS>
            <div><NodeType>VIP{vip}</NodeType> <NodeType i={identity + 1}>{IDENTITY_TYPE[identity]}</NodeType></div>
        </FlexBLock>
    )
}

function Node() {
    const node = useNodeData()
    return (
        <Container>
            {/* <FlexBLock>
                
            </FlexBLock>
            <WhiteSpace /> */}
            <FlexBLock>
                <TextMax><IconImg style={{width: '26px', height: 'auto', verticalAlign: 'inherit'}} src='./togetherness.png'/> Node</TextMax>
                <Price />
            </FlexBLock>
            <WhiteSpace />
            <Card type='j'>
                <div style={{textAlign: 'center'}}>
                    <TextM block>Reserve USDT</TextM>
                    <TextLinear linear='3' style={{fontSize: '32px'}} >{EtherToInt(node.totalInvested)}</TextLinear>
                </div>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <FlexBLock>
                    <div>
                        <TextM block>Withdrawable</TextM>
                        <TextLinear style={{fontSize: '24px'}} block>{EtherToInt(node.totalClaim)}</TextLinear> <TextM color='2'> / USDT</TextM>
                    </div>
                    <ClaimUSDT />
                </FlexBLock>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <FlexBLock>
                    <TextS color='2'>Direct Reward</TextS>
                    <TextS>{node.directReward} <TextS color='2'>USDT</TextS></TextS>
                </FlexBLock>
                <FlexBLock>
                    <TextS color='2'>Level-2 Reward</TextS>
                    <TextS>{node.level2Reward} <TextS color='2'>USDT</TextS></TextS>
                </FlexBLock>
                <FlexBLock>
                    <TextS color='2'>Team Reward</TextS>
                    <TextS color={node.identity === 0 ? '2': '1'}>{node.teamReward} <TextS color='2'>USDT</TextS></TextS>
                </FlexBLock>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <FlexBLock>
                    <div>
                        <TextS block color='2'>Ranking Bonus {/**<NodeType>NO.{node.userRankId}</NodeType> */}</TextS>
                        <TextM>{node.rankRewardedUSDT} <TextS color='2'>USDT</TextS></TextM>
                    </div>
                    <div style={{textAlign:'right'}}>
                        <TextS block color='2'> Current Queue</TextS>
                        <TextM>{ShortAddress(node.rankHeadAddress)}</TextM> 
                    </div>
                </FlexBLock>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <FlexBLock>
                    <div>
                        <TextS block color='2'>Shared Profit</TextS>
                        <TextM>{EtherToInt(node.shareReward)} <TextS color='2'>USDT</TextS></TextM>
                    </div>
                    <div style={{textAlign:'right'}}>
                        <TextS block color='2'> Share Ratio</TextS>
                        <TextM>{node.sharePercent}%</TextM> 
                    </div>
                </FlexBLock>
            </Card>
            <WhiteSpace />
            {/* {
                node.isNode === null?
                <div style={{textAlign: 'center'}}>
                    <CircularProgress color="inherit"/>
                </div>:
                // node.isNode === true ?
                <>
                    {
                        node.isNode === false ?
                        <>
                            <JoinNode registed={node.registed} usdtInvested={node.usdtInvested}/>
                            <WhiteSpace />
                        </> : null
                    }
                    <Card type='b' spacing={[0,0]} >
                        <TextM style={{padding: '0.6rem', display: 'flex', alignItems: 'center' }}>My Team <NodeType>VIP{node.vip}</NodeType> <NodeType i={5}>{IDENTITY_TYPE[node.identity]}</NodeType></TextM>
                        <Card>
                            <LoadingBlock>
                                {
                                    node.tree.map((v) => {
                                        return (
                                            <div key={v.user} style={{margin: '10px 0px 0px'}}>
                                                <TeamItem
                                                    user={v.user}
                                                    vip={v.vip}
                                                    identity={v.identity}
                                                    invested={v.invested}
                                                    style={{marginBottom: '8px'}}
                                                />
                                                {
                                                    v.children.map(v=> {
                                                        return (
                                                            <div key={v.user} style={{margin: '0px 0px 5px 16px'}}>
                                                                <TeamItem
                                                                    user={v.user}
                                                                    vip={v.vip}
                                                                    identity={v.identity}
                                                                    invested={v.invested}
                                                                />
                                                            </div>
                                                        )
                                                    })
                                                }
                                                <WhiteSpace />
                                                <Hr />
                                            </div>
                                        )
                                    })
                                }
                            </LoadingBlock>
                            
                        </Card>
                    </Card>

                </>
            } */}
        </Container>
    )
}

export default Node

const COLOR = [
    "rgb(171 255 0)",
    "rgb(168 195 255)",
    "rgb(255 241 0)",
    "rgb(255 0 161)",
    "rgb(0 242 255)",
    "rgb(255 244 150)"
]
function NodeType({children, i = 0}) {
    return <NodeBlock i={i}>{children}</NodeBlock>
}

const NodeBlock = styled('span')`
    background-color: ${p => COLOR[p.i] || COLOR[0]};
    color: #000;
    font-size: 10px;
    padding: 2px 4px;
    border-radius: 4px;
    margin-left: 4px;
    box-shadow: 0px 0px 6px #fdffb791;
`

const RulesBlock = styled('div')`
    background: rgb(9 9 9 / 82%);
    padding: 12px;
    border-radius: 12px;
    margin: 8px 0px;
`